import React, { ReactNode } from 'react';
import { splitByNewLine } from '../../utils/file-parsers';
import { Link } from 'react-router-dom';
import { ItemsToLinks } from 'routes/LinksInList';

interface Iprops {
    data: string;
    filterReplays: boolean;
    filterReleasedThisYear?: boolean;
    note: ReactNode | null;
}

export const OrderedListToNumberedList = (props: Iprops) => {
    const { data, filterReplays, filterReleasedThisYear, note } = props;

    const lines = splitByNewLine(data);
    const headerString = lines[0];
    let items = lines.slice(2, lines.length);
    if (filterReplays) {
        items = items.filter((item) => item.toLowerCase().indexOf("[replay]") < 0);
    }

    if (filterReleasedThisYear) {
        const yearPattern = /\(\d{4}\)/;
        items = items.filter((item) => !yearPattern.test(item));
    }


    return (
        <div>
            <h2>{headerString}</h2>
            <div>
                {items.map((item, index) => {
                    const specialLink = ItemsToLinks[item.toLowerCase()];
                    const display = specialLink != null
                        ? <Link to={specialLink}>{item}</Link>
                        : item;
                    return (
                        <div className="list-item" key={index}>
                            <span className="list-number">{index+1}.</span>
                            <span className="list-content">{display}</span>
                        </div>
                    )                    
                })}                    
            </div>
            {note &&
                <div>
                    <br />
                    <br />
                    {note}
                </div>
            }
        </div>
    );
};